module.exports = __webpack_public_path__ + "static/media/windDirection.a67e353b.svg";